module.exports = __webpack_public_path__ + "static/images/tag-bg-98.a987cfd.png";